module.exports = __webpack_public_path__ + "assets/img/3.0c6c7c1a.png";